import axios from 'axios';
import qs from 'qs';
import { ROUTES } from '../constants/routes';
import { serviceLocalStorage } from '../utils/serviceLocalStorage';

const createAxios = () => {
  const client = axios.create({
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' })
  });
  client.defaults.baseURL = process.env.REACT_APP_API_URL;
  client.defaults.withCredentials = false;

  client.defaults.headers.common.Authorization = `Bearer ${serviceLocalStorage.getAccessToken()}`;

  client.interceptors.request.use(
    (config) => {
      config.headers['Authorization'] = `Bearer ${serviceLocalStorage.getAccessToken()}`;
      config.headers['Source'] = 'admin'
      return config;
    },
    (error) => {
      Promise.reject(error);
    }
  );

  let isRefreshing = false;
  let failedQueue = [];

  const processQueue = (error, token = null) => {
    failedQueue.forEach((prom) => {
      if (error) {
        prom.reject(error);
      } else {
        prom.resolve(token);
      }
    });

    failedQueue = [];
  };

  client.interceptors.response.use(
    (response) => {
      return response;
    },
    async (err) => {
      const originalRequest = err.config;

      if (err.response?.status === 403 && !originalRequest._retry) {
        if (isRefreshing) {
          return new Promise(function (resolve, reject) {
            failedQueue.push({ resolve, reject });
          })
            .then((token) => {
              originalRequest.headers['Authorization'] = `Bearer ${token}`;
              return axios(originalRequest);
            })
            .catch((err) => {
              return Promise.reject(err);
            });
        }

        originalRequest._retry = true;
        isRefreshing = true;

        let formData = new FormData();
        formData.append('refresh_token', serviceLocalStorage.getRefreshToken());

        return new Promise(function (resolve, reject) {
          axios
            .post(`${process.env.REACT_APP_API_URL}${'/auth/refresh-token'}`, formData, {
              headers: {
                Authorization: `Bearer ${serviceLocalStorage.getAccessToken()}`
              }
            })
            .then(({ data }) => {
              serviceLocalStorage.setLocalStorage(data);

              client.defaults.headers.common.Authorization = `Bearer ${data.access_token}`;
              originalRequest.headers['Authorization'] = 'Bearer ' + data.access_token;
              processQueue(null, data.access_token);
              resolve(axios(originalRequest));
            })
            .catch((err) => {
              processQueue(err, null);
              reject(err);
              if (document.location.pathname !== ROUTES.LOGIN) {
                serviceLocalStorage.clearLocalStorage();
                document.location.href = ROUTES.LOGIN;
              }
            })
            .then(() => {
              isRefreshing = false;
            });
        });
      }

      if (err.response?.status === 401 && document.location.pathname !== ROUTES.LOGIN) {
        document.location.href = ROUTES.LOGIN;
      }

      return Promise.reject(err);
    }
  );

  return client;
};

export const apiClient = createAxios();
